module.exports = __webpack_public_path__ + "img/curve_2.c0345a09.png";